import { SvgIcon } from '@material-ui/core'

export default function CameraIcon(props: any) {
    return (
        <SvgIcon style={{ width: '26px', height: '26px' }} viewBox="0 0 28 28" fill="none" {...props}>
            <foreignObject x="-40.1694" y="-35.6699" width="108.755" height="99.3379"></foreignObject>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.54448 8.22907C0.999512 9.29863 0.999512 10.6988 0.999512 13.499V14.499C0.999512 17.2993 0.999512 18.6994 1.54448 19.769C2.02385 20.7098 2.78875 21.4747 3.72956 21.9541C4.79912 22.499 6.19925 22.499 8.99951 22.499H10.9995C13.7998 22.499 15.1999 22.499 16.2695 21.9541C17.2103 21.4747 17.9752 20.7098 18.4545 19.769C18.9995 18.6994 18.9995 17.2993 18.9995 14.499V13.499C18.9995 10.6988 18.9995 9.29863 18.4545 8.22907C17.9752 7.28826 17.2103 6.52336 16.2695 6.04399C15.1999 5.49902 13.7998 5.49902 10.9995 5.49902H8.99951C6.19925 5.49902 4.79912 5.49902 3.72956 6.04399C2.78875 6.52336 2.02385 7.28826 1.54448 8.22907ZM24.6493 10.145C25.8075 9.31767 27.4164 10.1456 27.4164 11.569V16.4345C27.4164 17.8579 25.8075 18.6859 24.6493 17.8586L21.2434 15.4258C20.2663 14.7279 20.2663 13.2757 21.2434 12.5778L24.6493 10.145Z"
                fill="url(#paint0_linear_1373_15928)"
            />
            <defs>
                <clipPath id="bgblur_0_1373_15928_clip_path" transform="translate(40.1694 35.6699)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.54448 8.22907C0.999512 9.29863 0.999512 10.6988 0.999512 13.499V14.499C0.999512 17.2993 0.999512 18.6994 1.54448 19.769C2.02385 20.7098 2.78875 21.4747 3.72956 21.9541C4.79912 22.499 6.19925 22.499 8.99951 22.499H10.9995C13.7998 22.499 15.1999 22.499 16.2695 21.9541C17.2103 21.4747 17.9752 20.7098 18.4545 19.769C18.9995 18.6994 18.9995 17.2993 18.9995 14.499V13.499C18.9995 10.6988 18.9995 9.29863 18.4545 8.22907C17.9752 7.28826 17.2103 6.52336 16.2695 6.04399C15.1999 5.49902 13.7998 5.49902 10.9995 5.49902H8.99951C6.19925 5.49902 4.79912 5.49902 3.72956 6.04399C2.78875 6.52336 2.02385 7.28826 1.54448 8.22907ZM24.6493 10.145C25.8075 9.31767 27.4164 10.1456 27.4164 11.569V16.4345C27.4164 17.8579 25.8075 18.6859 24.6493 17.8586L21.2434 15.4258C20.2663 14.7279 20.2663 13.2757 21.2434 12.5778L24.6493 10.145Z"
                    />
                </clipPath>
                <linearGradient
                    id="paint0_linear_1373_15928"
                    x1="8.62992"
                    y1="5.50021"
                    x2="8.62992"
                    y2="28.2681"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.15" />
                </linearGradient>
            </defs>
        </SvgIcon>
    )
}
